module.exports = __webpack_public_path__ + "media/images/landing-pages/lp-pri-crs-1-1ddb3e5ac63f96b8bd87fcc81dff164d.png";